// extracted by mini-css-extract-plugin
module.exports = {"album":"_albumComponent_album__6Z8Gm","title":"_albumComponent_title__0frgr","learn":"_albumComponent_learn__g80Hv"};